import { render } from "./SalesLostReport.vue?vue&type=template&id=baefc364&scoped=true"
import script from "./SalesLostReport.vue?vue&type=script&lang=js"
export * from "./SalesLostReport.vue?vue&type=script&lang=js"

import "./SalesLostReport.vue?vue&type=style&index=0&id=baefc364&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baefc364"]])

export default __exports__